exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".SlideImages1 amp-img{width:100%}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/contents/SlideImages1/src/components/contents/SlideImages1/SlideImages1.s.scss"],"names":[],"mappings":"AAEA,sBAEI,UAAW,CACZ","file":"SlideImages1.scss","sourcesContent":["@import '~scss/variables';\n\n.SlideImages1 {\n  amp-img {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/components/contents/SlideImages1/SlideImages1.scss
// module id = 1117
// module chunks = 88